module.exports = __webpack_public_path__ + "img/chess_chessblack6.ca7b5737.png";